import { render } from "./Backgrounds.vue?vue&type=template&id=10fd00fd&scoped=true"
import script from "./Backgrounds.vue?vue&type=script&lang=js"
export * from "./Backgrounds.vue?vue&type=script&lang=js"

import "./Backgrounds.vue?vue&type=style&index=0&id=10fd00fd&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fd00fd"]])

export default __exports__